export const useTreshold = ({
    company,
    score_key,
    array,
    category,
}: {
    company: any
    score_key: string
    array: boolean
    category: string | null
}) => {
    let score = 0

    if (category) {
        const cat = array ? company.scores.find((item: any) => item.category === category) : company.find((item: any) => item.category === category)

        score = useFormatScore(cat[score_key])
    }
    else {
        score = useFormatScore(company[score_key])
    }

    if (score >= 75) {
        return {
            treshold: 1,
            default: '#79DD7D',
            light: '#DFFEE0',
            dark: '#3D8A40',
        }
    }
    if (score >= 50 && score < 75) {
        return {
            treshold: 2,
            default: '#FFE981',
            light: '#FBFFE0',
            dark: '#8E9B3F',
        }
    }
    if (score >= 25 && score < 50) {
        return {
            treshold: 3,
            default: '#E89903',
            light: '#FCF3E2',
            dark: '#634100',
        }
    }
    if (score >= 0 && score < 25) {
        return {
            treshold: 4,
            default: '#FF6464',
            light: '#FDE1E1',
            dark: '#D86300',
        }
    }
    /* if (score < 20) {
        return {
            treshold: 5,
            default: '#D9D9D9',
            light: '#929292',
            dark: '#929292',
        }
    } */
}
